/* ============ Article content extras ============ */

/* Lightbox for gallery and inline content images */
(function () {
  if (typeof lightbox === 'function') {
    lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
  }
})();

/* Responsive video embeds (YouTube, Vimeo, etc.) in post content */
(function () {
  if (typeof reframe !== 'function') return;
  var sources = [
    '.gh-content iframe[src*="youtube.com"]',
    '.gh-content iframe[src*="youtube-nocookie.com"]',
    '.gh-content iframe[src*="player.vimeo.com"]',
    '.gh-content object',
    '.gh-content embed',
  ];
  reframe(document.querySelectorAll(sources.join(',')));
})();

/* Responsive HTML tables */
(function () {
  $$('.gh-content > table').forEach(function (table) {
    var wrapper = document.createElement('div');
    wrapper.className = 'gh-table';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
})();

/* Toggle cards: open/close state for keyboard + mouse */
(function () {
  $$('.kg-toggle-heading').forEach(function (heading) {
    heading.addEventListener('click', function () {
      var card = heading.closest('.kg-toggle-card');
      if (card) card.classList.toggle('kg-toggle-card--toggle-open');
    });
  });
})();
